// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Skeleton, Space, Stack } from '@mantine/core';
import { FC } from 'react';
import { useMailOutboundConfigs } from '../../../Service/hooks/useMailOutboundConfigs';
import { MailOutBoundConfigDTO } from '../../../Types/MailT';
import { useImapStore } from '../../../Service/hooks/useImapStore';
import DefaultFolder from './DefaultFolderNav';

const MailOutboundConfigNav: FC<{ closeNavBar: () => void }> = ({ closeNavBar }) => {
  const { loading, mailOutboundConfigs } = useMailOutboundConfigs();

  if (loading) {
    return <Skeleton width="100%" height={200} />;
  }

  return (
    <Stack>
      {mailOutboundConfigs.map((cfg) => (
        <MailOutboundConfigDefaultFolderIMAP key={cfg.id} config={cfg} closeNavBar={closeNavBar} />
      ))}
    </Stack>
  );
};

const MailOutboundConfigDefaultFolderIMAP: FC<{ config: MailOutBoundConfigDTO; closeNavBar: () => void }> = ({
  config,
  closeNavBar,
}) => {
  const { loadingFolder, defaultFolder } = useImapStore(config);

  return (
    <div>
      <Space h="xl" />
      {loadingFolder && <Skeleton height={300} />}
      {defaultFolder && <DefaultFolder config={config} folder={defaultFolder} closeNavBar={closeNavBar} />}
    </div>
  );
};

export default MailOutboundConfigNav;
